export default {
  SET_PAYMENTS(state, payments) {
    state.payments = payments
  },
  REMOVE_RECORD(state, itemId) {
    const userIndex = state.users.findIndex((u) => u.userID === itemId)

    state.users.splice(userIndex, 1)
  },
  UPDATE_USER(state, data) {
    const userIndex = state.users.findIndex((u) => u.userID === data.user.userID)

    if (data.path != '') state.users[userIndex].avatar = data.path
    // if (data.user.userID == this.$store.state.AppActiveUser) localStorage.setItem('userInfo') = state.users[userIndex]
  },
  APPROVE_PAYMENT(state, data) { 
    const paymentIndex = state.payments.findIndex((u) => u._id === data)
    state.payments[paymentIndex].status = 'Approved'
    state.payments[paymentIndex].statusComment = ''
  },
  REJECT_PAYMENT(state, data) { 
    const paymentIndex = state.payments.findIndex((u) => u._id === data.userId)


    state.payments[paymentIndex].status = 'Rejected'
    state.payments[paymentIndex].statusComment = data.reason

  }
}
